import { Slot } from '@radix-ui/react-slot';
import type { VariantProps } from 'class-variance-authority';
import type { ComponentProps } from 'react';
import { listItemVariants } from '@/ui-kit/components/List';
import type { WithAsChild } from '@/ui-kit/types/utils';
import { cn } from '@/ui-kit/utils';

export const DataList = (props: ComponentProps<'dl'>) => <dl {...props} />;

type DataListItemProps = WithAsChild<ComponentProps<'div'> & VariantProps<typeof listItemVariants>>;

export const DataListItem = ({ asChild = false, className, size, ...props }: DataListItemProps) => {
  const Component = asChild ? Slot : 'div';
  return (
    <Component
      className={cn(listItemVariants({ size }), 'flex items-center justify-between gap-2', className)}
      {...props}
    />
  );
};

export const DataListLabel = ({ className, ...props }: ComponentProps<'dt'>) => (
  <dt className={cn('text-body-regular', className)} {...props} />
);

export const DataListValue = ({ className, ...props }: ComponentProps<'dd'>) => (
  <dd className={cn('text-body-regular text-end', className)} {...props} />
);
